<div class="container">
  <ghs-header [standalone]="true"></ghs-header>

  <div class="menu">
    <label>
      <span [ghs-label]="'settings.edition'"></span>
      <select [(ngModel)]="edition" (change)="update(); updateQueryParams()">
        @for (edition of gameManager.editions(true); track edition) {
        <option [value]="edition">
          <span [ghs-label]="'data.edition.' + edition"></span>
        </option>
        }
      </select>
    </label>
  </div>

  @if (edition) {
  <div class="treasures">
    @for (treasure of treasures | trackUUID; track treasure._trackUUID) {
    <div class="treasure">
      <span class="index">{{treasure.index}}</span>
      <ghs-treasure-label class="placeholder text-white" [treasure]="treasure" [edition]="edition"></ghs-treasure-label>
    </div>
    }
  </div>
  }
</div>